import React, { FC, SVGProps } from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const SuccessRingBadgeIcon: FC<SVGComponentProps & SVGProps<SVGSVGElement>> = ({
  width = 48,
  height = 48,
  className = undefined,
  ...props
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <rect width={48} height={48} rx={23.1724} fill="#DCFCE8" />
      <path
        d="M23.586 9.10352C15.3929 9.10352 8.68945 15.807 8.68945 24.0001C8.68945 32.1932 15.3929 38.8966 23.586 38.8966C31.7791 38.8966 38.4826 32.1932 38.4826 24.0001C38.4826 15.807 31.7791 9.10352 23.586 9.10352ZM23.586 35.9173C17.0166 35.9173 11.6688 30.5694 11.6688 24.0001C11.6688 17.4307 17.0166 12.0828 23.586 12.0828C30.1554 12.0828 35.5032 17.4307 35.5032 24.0001C35.5032 30.5694 30.1554 35.9173 23.586 35.9173ZM30.4235 17.4158L20.6067 27.2326L16.7485 23.3893L14.6481 25.4897L20.6067 31.4483L32.5239 19.5311L30.4235 17.4158Z"
        fill="#16A34A"
      />
    </svg>
  </SVGUniqueID>
);

export { SuccessRingBadgeIcon };
